export default {"src":"/_next/static/image/components/ui/Icon/icons/doc-with-cross.4dcd5ac6beff5d0022eea26fad7d549d.svg","height":63,"width":50};